module.exports = __webpack_public_path__ + "static/media/caution.c6b8a48f.png";